import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { canViewFeedType } from '../../../utils/access'
import NoAccessPage from '../errors/NoAccessPage'
import NewsLanding from './NewsLanding'

const LandingPage = () => {
    const team = useSelector(state => state.current_team.team)
    const user = useSelector(state => state.current_user.user)

    if (!team?.id) return <Redirect to='/switch_acc' />
    if (!team.approved_at) return <Redirect to='/requested' />
    if (!canViewFeedType({ typeKey: 'all', team, user })) return <NoAccessPage />
    return <NewsLanding />
}

export default LandingPage
